/******** quickcart.js ********/
class QuickCart {
  promoProps: PromoProps
  elementIDs: ElementIDs
  lightboxProps: LightboxProps
  cartItems: [CartItems?]
  hasSubInCartNote: string
  constructor({
    promoProps,
    elementIDs,
    lightboxProps,
    cartItems,
    hasSubInCartNote
  }) {
    const defaultElementIds = {
      lightboxCart: {
        lbSumQty: '#lbSumQty',
        lbCashSubtotal: '#lbCashSubtotal',
        lbPointsSubtotal: '#lbPointsSubtotal',
        lbItemContainerPrefix: '#lbItem',
        lbImagePrefix: '#lbImage',
        lbProdNamePrefix: '#lbProdName',
        lbCurrentPricePrefix: '#lbCurrentPrice',
        lbCurrentPointsPrefix: '#lbCurrentPoints',
        lbListPricePrefix: '#lbListPrice',
        lbListPointsPrefix: '#lbListPoints',
        lbExtPrefix: '#lbExt',
        lbQtyPrefix: '#lbQty'
      },
      headerCart: {
        cartSumQty: '#cartSumQty',
        labelAux: '#labelAux',
        bubbleCnt: '#bubble-cnt',
        DIVitemHead: '#DIVitemHead',
        DIVcartSumItemsList: '#DIVcartSumItemsList',
        DIVNoItem: '#DIVNoItem',
        ulMarkupDIVcartSumItemsList:
          '<ul><li class="Qty"></li><li class="ItemDescr"></li><li class="Price price-cash"></li><li class="Price price-points" style="display:none;visibility:hidden;"></li></ul>',
        hdCashSubtotal: '#hdCashSubtotal',
        hdPointsSubtotal: '#hdPointsSubtotal',
        hdPointsSubtotalDiscount: '#hdPointsSubtotalDiscount',
        hdQtyClass: '.Qty',
        hdItemDescrClass: '.ItemDescr',
        hdCashClass: '.price-cash',
        hdPointsClass: '.price-points'
      }
    }
    this.promoProps = promoProps || {}
    this.elementIDs = {
      ...defaultElementIds,
      ...elementIDs
    }
    this.lightboxProps = lightboxProps
    this.hasSubInCartNote = hasSubInCartNote
    this.cartItems = cartItems
  }

  get _cartItems() {
    return this.cartItems
  }

  set _cartItems(newCartItems) {
    this.cartItems = newCartItems
  }

  getPromoValue(name: string): string {
    return this.promoProps[name]
  }

  setPromoValue(name: string, value: string): void {
    this.promoProps[name] = value
  }

  populateItemUl(ct: number): void{
		let htmlString='';
		for (let i = 0; i < ct; i++) {
			htmlString+=this.lightboxProps.lbItemWrapUl.replace(/%K%/g,i.toString())
		}		
		htmlString+=this.lightboxProps.lbItemWrapAfterUl
		$('#lbItemWrap').html(htmlString)
		$('#continueShoppingBtn').on('click', () => {
      CommonUtils.hideElement('overlay_LB');
    });
  }

  updateQuickCart(
    justAddedArray: JustAddedArray[],
    ajaxResults: string,
    productIndex: number,
    triggerElement?: HTMLElement
  ): void {
    if (ajaxResults !== '') {
      let sumCartQty = 0
      const dsItemRowCount = CommonUtils.getXMLDataTableRowCount(
        'dsBasket',
        1,
        ajaxResults
      )
      for (let i = 0; i < dsItemRowCount; i++) {
        sumCartQty += Number.parseInt(
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'qtyOrd',
            ajaxResults
          )
        )
      }
      const bubbleCnt = $(this.elementIDs.headerCart.bubbleCnt)
      const labelAux = $(this.elementIDs.headerCart.labelAux)
      if (bubbleCnt.length) {
        $(this.elementIDs.headerCart.cartSumQty).show()
        bubbleCnt.html(sumCartQty.toString())
        labelAux.html(`${sumCartQty.toString() === '1' ? 'item' : 'items'}`)
      }
	  this.populateItemUl(justAddedArray.length)
      for (let ct = 0; ct < this.lightboxProps.numItemContainer; ct++) {
        const lbItemContainer = $(
          `${this.elementIDs.lightboxCart.lbItemContainerPrefix}${ct}`
        )
        if (justAddedArray.length > ct) {
          if (lbItemContainer.length) {
            const lbItemImage = $(
              `${this.elementIDs.lightboxCart.lbImagePrefix}${ct}`
            )
            const lbItemName = $(
              `${this.elementIDs.lightboxCart.lbProdNamePrefix}${ct}`
            )
            const lbItemCurrentPrice = $(
              `${this.elementIDs.lightboxCart.lbCurrentPricePrefix}${ct}`
            )
            const lbItemCurrentPoints = $(
              `${this.elementIDs.lightboxCart.lbCurrentPointsPrefix}${ct}`
            )
            const lbItemListPrice = $(
              `${this.elementIDs.lightboxCart.lbListPricePrefix}${ct}`
            )
            const lbItemListPoints = $(
              `${this.elementIDs.lightboxCart.lbListPointsPrefix}${ct}`
            )
            const lbItemQty = $(
              `${this.elementIDs.lightboxCart.lbQtyPrefix}${ct}`
            )
            lbItemImage.attr('src', justAddedArray[ct].image)
            lbItemImage.attr('alt', justAddedArray[ct].descr)
            lbItemName.html(justAddedArray[ct].descr)
            if (justAddedArray[ct].extensionGroup !== '') {
              const tmpExtNameArray = justAddedArray[ct].extension.split(';')
              for (
                let x = 0;
                x < this.lightboxProps.maxNumExtenionPerItem;
                x++
              ) {
                if (
                  tmpExtNameArray[x] !== '' &&
                  tmpExtNameArray[x] !== undefined
                ) {
                  $(
                    `${this.elementIDs.lightboxCart.lbExtPrefix}${ct}-${x}`
                  ).html(tmpExtNameArray[x])
                } else {
                  $(
                    `${this.elementIDs.lightboxCart.lbExtPrefix}${ct}-${x}`
                  ).html('')
                }
              }
            }
            if (justAddedArray[ct].invtID.toUpperCase().indexOf('SUB') === -1) {
              if (justAddedArray[ct].points !== justAddedArray[ct].listpoints) {
                lbItemListPoints.html(
                  `<span aria-hidden="false" class="only-readers">Regular price</span> ${CommonUtils.formatPoints(justAddedArray[ct].listpoints)} Points`
                )
                lbItemCurrentPoints.html(
                  `<span aria-hidden="false" class="only-readers">Sale price</span> ${CommonUtils.formatPoints(justAddedArray[ct].points)} Points`
                )
              } else {
                lbItemListPoints.html('')
                lbItemCurrentPoints.html(
                  `${CommonUtils.formatPoints(justAddedArray[ct].points)} Points`
                )
              }
            } else {
              lbItemListPoints.html('')
              lbItemCurrentPoints.html('NA')
            }
            if (justAddedArray[ct].price !== justAddedArray[ct].listprice) {
              SalesforceAbandonedCartUtils.addCartOrOrderData({
                item: justAddedArray[ct].itemID,
                quantity: justAddedArray[ct].qty,
                price: justAddedArray[ct].listprice,
                salePrice: justAddedArray[ct].price,
                uniqueId: justAddedArray[ct].invtID
              })
              lbItemListPrice.html(
                CommonUtils.formatCurrency(justAddedArray[ct].listprice)
              )
              lbItemCurrentPrice.html(
                CommonUtils.formatCurrency(justAddedArray[ct].price)
              )
            } else {
              SalesforceAbandonedCartUtils.addCartOrOrderData({
                item: justAddedArray[ct].itemID,
                quantity: justAddedArray[ct].qty,
                price: justAddedArray[ct].listprice,
                salePrice: undefined,
                uniqueId: justAddedArray[ct].invtID
              })
              lbItemListPrice.html('')
              lbItemCurrentPrice.html(
                CommonUtils.formatCurrency(justAddedArray[ct].price)
              )
            }
            if (
              justAddedArray[ct].qty !== '0' &&
              justAddedArray[ct].qty !== ''
            ) {
              lbItemQty.html(justAddedArray[ct].qty)
            }
            lbItemContainer.show()
          }
        } else {
          lbItemContainer.hide()
        }
      }
      SalesforceAbandonedCartUtils?.trackCart()
      //GA Remarketing
      trackATC(dsItemRowCount, ajaxResults, justAddedArray)
      $(this.elementIDs.headerCart.DIVNoItem).hide()
      $(this.elementIDs.headerCart.DIVitemHead).show()
      $(this.elementIDs.headerCart.DIVcartSumItemsList).show()
      $(this.elementIDs.headerCart.DIVcartSumItemsList).html('')
      $(this.elementIDs.headerCart.DIVcartSumItemsList).append(
        `<span class="points-ui info-ui" style="display:none;visibility:hidden;">${this.hasSubInCartNote}</span>`
      )
      for (let i = 0; i < dsItemRowCount; i++) {
        $(this.elementIDs.headerCart.DIVcartSumItemsList).append(
          this.elementIDs.headerCart.ulMarkupDIVcartSumItemsList
        )
        const currentBasketID = CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'basketID',
          ajaxResults
        )
        const dsBasketExtensionsCount = CommonUtils.getXMLDataTableRowCount(
          'dsBasketExtensions',
          0,
          ajaxResults
        )
        let sumProdName = CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'Descr',
          ajaxResults
        )
        sumProdName = sumProdName
          .replace('&lt;br&gt;', '<br>')
          .replace('&lt;sup&gt;', '<sup>')
          .replace('&lt;/sup&gt;', '</sup>')
        let ItemDescrString = `<p><span>${sumProdName}</span>`
        for (let be = 0; be < dsBasketExtensionsCount; be++) {
          if (
            currentBasketID ===
            CommonUtils.getXMLDataFieldValue(
              'dsBasketExtensions',
              0,
              be,
              'basketID',
              ajaxResults
            )
          ) {
            ItemDescrString += `<span>${CommonUtils.getXMLDataFieldValue('dsBasketExtensions', 0, be, 'Descr', ajaxResults)}</span>`
          }
        }
        ItemDescrString += '</p>'
        $(
          `${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdItemDescrClass}`
        ).html(ItemDescrString)
        $(
          `${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdCashClass}`
        ).html(
          CommonUtils.formatCurrency(
            CommonUtils.getXMLDataFieldValue(
              'dsBasket',
              1,
              i,
              'CurySlsPrice',
              ajaxResults
            )
          )
        )
        if (
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'alternateID',
            ajaxResults
          )
            .toUpperCase()
            .indexOf('SUB') === -1
        ) {
          $(
            `${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdPointsClass}`
          ).html(
            `${CommonUtils.formatPoints(CommonUtils.getXMLDataFieldValue('dsBasket', 1, i, 'User5', ajaxResults))} Points`
          )
        } else {
          $(
            `${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdPointsClass}`
          ).html('NA')
        }
        $(
          `${this.elementIDs.headerCart.DIVcartSumItemsList} ul:nth-child(${i + 2}) ${this.elementIDs.headerCart.hdQtyClass}`
        ).html(
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'QtyOrd',
            ajaxResults
          )
        )
      }
      const lbSumQty = $(this.elementIDs.lightboxCart.lbSumQty)
      if (lbSumQty.length) {
        const lbSumQtyString = `${Number.parseInt(sumCartQty.toString())} item${sumCartQty > 1 ? 's' : ''}`
        lbSumQty.html(lbSumQtyString)
      }
      const lbCashSubtotal = $(this.elementIDs.lightboxCart.lbCashSubtotal)
      if (lbCashSubtotal.length) {
        lbCashSubtotal.html(
          CommonUtils.formatCurrency(
            CommonUtils.getXMLDataFieldValue(
              'dsBasket',
              0,
              0,
              'curyTotMerch',
              ajaxResults
            )
          )
        )
      }
      const lbPointsSubtotal = $(this.elementIDs.lightboxCart.lbPointsSubtotal)
      if (lbPointsSubtotal.length) {
        lbPointsSubtotal.html(
          `${CommonUtils.formatPoints(CommonUtils.getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`
        )
      }
      const hdCashSubtotal = $(this.elementIDs.headerCart.hdCashSubtotal)
      if (hdCashSubtotal.length) {
        hdCashSubtotal.html(
          CommonUtils.formatCurrency(
            CommonUtils.getXMLDataFieldValue(
              'dsBasket',
              0,
              0,
              'curyTotMerch',
              ajaxResults
            )
          )
        )
      }
      const hdPointsSubtotal = $(this.elementIDs.headerCart.hdPointsSubtotal)
      if (hdPointsSubtotal.length) {
        hdPointsSubtotal.html(
          `${CommonUtils.formatPoints(CommonUtils.getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`
        )
      }
      const hdPointsSubtotalDiscount = $(
        this.elementIDs.headerCart.hdPointsSubtotalDiscount
      )
      if (hdPointsSubtotalDiscount.length) {
        hdPointsSubtotalDiscount.html(
          `${CommonUtils.formatPoints(CommonUtils.getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults))} Points`
        )
      }
      if (this.promoProps.promoType !== undefined) {
        if (this.promoProps.promoType.toUpperCase() === 'BMSM') {
          getBMSMTotals(ajaxResults, sumCartQty)
        }
      }
      CommonUtils.showElement('DIVcartbtns')
      CommonUtils.showElement('overlay_LB')
      HAHAccessibility.trapFocus({
        container: '.lbCartFocusTrap',
        closeElement: '#overlay_LB',
        additionalCloseElements: ['#closeLbBtn'],
        tablistUpdateElements: [],
        triggerHTMLElement: triggerElement
      })
    }
    CommonUtils.showHideLoader('hide', productIndex)
  }

  displayPromoTotals(toggledView: string): void {
    if (this.getPromoValue('active')) {
      if (toggledView === 'points') {
        $('#lbCashSubtotalUL').hide()
        $('#lbDiscountSummary').hide()
        $('#lbPointsSubtotalUL').show()
        $('#hdULDiscount').hide()
        $('#hdULNoDiscount').show()
      } else {
        $('#lbCashSubtotalUL').hide()
        $('#lbDiscountSummary').show()
        $('#lbPointsSubtotalUL').hide()
        $('#hdULDiscount').show()
        $('#hdULNoDiscount').hide()
      }
    }
  }
}
const quickCartObj = new QuickCart(classOptions)

function trackATC(
  dsItemRowCount: number,
  ajaxResults: string,
  justAddedArray: JustAddedArray[]
): void {
  const cartViewAdobeLaunch = [] // Adobe Launch
  const cartProductsAW = [] // Google Remarketing
  const addToCartGA4 = [] //GA4 add-to-cart
  const newCartItems: [CartItems?] = [] //new cartItems array post add-to-cart
  const dsItemExtensionCount = CommonUtils.getXMLDataTableRowCount(
    'dsBasketExtensions',
    0,
    ajaxResults
  )
  const dsItemExtension = []
  let tmpIndex = 0
  for (let i = 0; i < dsItemExtensionCount; i++) {
    dsItemExtension.push({
      basketID: CommonUtils.getXMLDataFieldValue(
        'dsBasketExtensions',
        0,
        i,
        'basketID',
        ajaxResults
      ),
      sortIndex: Number.parseInt(
        CommonUtils.getXMLDataFieldValue(
          'dsBasketExtensions',
          0,
          i,
          'sortIndex',
          ajaxResults
        )
      ),
      extensionName: CommonUtils.getXMLDataFieldValue(
        'dsBasketExtensions',
        0,
        i,
        'name',
        ajaxResults
      )
    })
  }
  for (let i = 0; i < dsItemRowCount; i++) {
    const matchedItem = quickCartObj._cartItems.find(
      (item) =>
        item.invtID ===
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'invtid',
            ajaxResults
          ) &&
        item.altID ===
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'alternateid',
            ajaxResults
          )
    )
    let addedQty = 0
    if (matchedItem == undefined) {
      addedQty = Number.parseInt(
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'qtyOrd',
          ajaxResults
        )
      )
    } else {
      const newQty = Number.parseInt(
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'qtyOrd',
          ajaxResults
        )
      )
      if (newQty > matchedItem.quantity) {
        addedQty = newQty - matchedItem.quantity
      }
    }
    let addedCategory = CommonUtils.getXMLDataFieldValue(
      'dsBasket',
      1,
      i,
      'categoryName',
      ajaxResults
    )
    let addedCategoryID = CommonUtils.getXMLDataFieldValue(
      'dsBasket',
      1,
      i,
      'categoryID',
      ajaxResults
    )
    if (addedQty !== 0) {
      if (addedCategory === '') {
        const tempItemID = justAddedArray[0].itemID
        try {
          addedCategory = classOptions.itemProps[tempItemID].categoryName
          addedCategoryID = classOptions.itemProps[tempItemID].categoryID
        } catch (error) {
          addedCategory = 'N/A'
          addedCategoryID = 'N/A'
        }
      }
      let tmpVariant = ''
      const matchedItemExtension = dsItemExtension.filter(
        (elem) =>
          elem.basketID ===
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'basketID',
            ajaxResults
          )
      )
      if (matchedItemExtension !== undefined) {
        matchedItemExtension.sort(
          (a: { sortIndex: number }, b: { sortIndex: number }) =>
            a.sortIndex - b.sortIndex
        )
        tmpVariant = matchedItemExtension
          .map((item: { extensionName: string }) => item.extensionName)
          .join(';')
      }
      addToCartGA4.push({
        item_name: CommonUtils.parseXMLData(
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'Descr',
            ajaxResults
          )
        ),
        item_id: CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'itemid',
          ajaxResults
        ),
        affiliation: classOptions.affiliation,
        price:
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'itemid',
            ajaxResults
          )
            .toUpperCase()
            .indexOf('-SUB') !== -1
            ? Number.parseFloat(
                CommonUtils.getXMLDataFieldValue(
                  'dsBasket',
                  1,
                  i,
                  'CurySlsPrice',
                  ajaxResults
                )
              )
            : Number.parseFloat(
                CommonUtils.getXMLDataFieldValue(
                  'dsBasket',
                  1,
                  i,
                  'CuryListPrice',
                  ajaxResults
                )
              ),
        discount:
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'itemid',
            ajaxResults
          )
            .toUpperCase()
            .indexOf('-SUB') !== -1
            ? 0
            : Number(
                (
                  Number.parseFloat(
                    CommonUtils.getXMLDataFieldValue(
                      'dsBasket',
                      1,
                      i,
                      'CuryListPrice',
                      ajaxResults
                    )
                  ) -
                  Number.parseFloat(
                    CommonUtils.getXMLDataFieldValue(
                      'dsBasket',
                      1,
                      i,
                      'CurySlsPrice',
                      ajaxResults
                    )
                  )
                ).toFixed(2)
              ),
        item_variant: CommonUtils.parseXMLData(tmpVariant),
        subscription:
          CommonUtils.getXMLDataFieldValue(
            'dsBasket',
            1,
            i,
            'itemid',
            ajaxResults
          )
            .toUpperCase()
            .indexOf('-SUB') !== -1
            ? 'yes'
            : 'no',
        item_brand: classOptions.item_brand,
        item_category: CommonUtils.parseXMLData(addedCategory),
        quantity: addedQty || 1,
        index: tmpIndex,
        item_list_id: CommonUtils.parseXMLData(addedCategoryID),
        item_list_name: CommonUtils.parseXMLData(addedCategory)
      })
      tmpIndex++
    }
    newCartItems.push({
      invtID: CommonUtils.getXMLDataFieldValue(
        'dsBasket',
        1,
        i,
        'invtid',
        ajaxResults
      ),
      altID: CommonUtils.getXMLDataFieldValue(
        'dsBasket',
        1,
        i,
        'alternateid',
        ajaxResults
      ),
      quantity: Number.parseInt(
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'qtyOrd',
          ajaxResults
        )
      )
    })
    cartViewAdobeLaunch.push({
      name: CommonUtils.parseXMLData(
        CommonUtils.getXMLDataFieldValue('dsBasket', 1, i, 'descr', ajaxResults)
      ),
      sku: CommonUtils.getXMLDataFieldValue(
        'dsBasket',
        1,
        i,
        'invtid',
        ajaxResults
      ),
      price: Number.parseFloat(
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'CurySlsPrice',
          ajaxResults
        )
      ).toFixed(2),
      quantity:
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'qtyOrd',
          ajaxResults
        ) || 1,
      category: CommonUtils.parseXMLData(
        CommonUtils.getXMLDataFieldValue(
          'dsBasket',
          1,
          i,
          'categoryname',
          ajaxResults
        )
      )
    })
  }
  quickCartObj._cartItems = newCartItems
  for (let ct = 0; ct < justAddedArray.length; ct++) {
    cartProductsAW.push({
      id: justAddedArray[ct].itemID.replace('-SUB-12', '').replace('-SUB', ''),
      google_business_vertical: 'retail'
    })
  }
  const mainItem = {
    id: justAddedArray[0].itemID,
    name: justAddedArray[0].descr,
    category: classOptions.itemProps[justAddedArray[0].itemID].categoryName,
    value: Number(
      Number(justAddedArray[0].price) * Number(justAddedArray[0].qty)
    ).toFixed(2)
  }
  const totalValueAddToCart = Number(
    addToCartGA4
      .reduce(
        (
          total: number,
          item: { price: number; quantity: number; discount: number }
        ) => total + (item.price - item.discount) * item.quantity,
        0
      )
      .toFixed(2)
  )
  //GA4 add_to_cart
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'USD',
      value: totalValueAddToCart,
      items: addToCartGA4
    },
    event_value: totalValueAddToCart,
    event_items: cartProductsAW,
    mainItem: mainItem
  })
  //Adobe Launch
  dataLayer.cartView = {
    products: cartViewAdobeLaunch,
    totalCost: CommonUtils.getXMLDataFieldValue(
      'dsBasket',
      0,
      0,
      'curyTotMerch',
      ajaxResults
    ),
    currencyCode: 'USD'
  }
}

/******* Interfaces *******/

interface JustAddedArray {
  itemID: string
  invtID: string
  descr: string
  image: string
  extensionGroup: string
  extension: string
  price: string
  listprice: string
  points: string
  listpoints: string
  qty: string
}

interface productJustAdded {
  invtID: string
  category: string
  altID: string
}

interface ElementIDs {
  lightboxCart: {
    lbSumQty: string
    lbSubtotal: string
    lbCashSubtotal: string
    lbPointsSubtotal: string
    lbItemContainerPrefix: string
    lbImagePrefix: string
    lbProdNamePrefix: string
    lbCurrentPricePrefix: string
    lbListPricePrefix: string
    lbCurrentPointsPrefix: string
    lbListPointsPrefix: string
    lbExtPrefix: string
    lbQtyPrefix: string
  }
  headerCart: {
    labelAux: string
    cartSumQty: string
    bubbleCnt: string
    DIVitemHead: string
    DIVcartSumItemsList: string
    DIVNoItem: string
    ulMarkupDIVcartSumItemsList: string
    hdItemDescrClass: string
    hdCashClass: string
    hdPointsClass: string
    hdQtyClass: string
    hdSubtotal: string
    hdQty: string
    hdItemDescr: string
    hdPrice: string
    hdCashSubtotal: string
    hdPointsSubtotal: string
    hdPointsSubtotalDiscount: string
  }
}
